import { InjectionToken } from '@angular/core';

import { MenuData } from './types';

export const MENU_DATA = new InjectionToken<MenuData>('MenuData');
